<template>
  <!-- <div id="payment_page" v-if="loading === false"> -->
  <div class="index">
    <div class="gradient"></div>
    <div class="content">
      <img src="@/assets/MontyPay.png" alt="MontyPay" class="main-logo" />
      <h1 class="heading">MontyPay Payment Gateway</h1>
      <form
        @submit.prevent="submit"
        class="form"
        v-if="previous_customer === false"
      >
        <label class="label">
          <input type="radio" :checked="save_card" @click="toggleSaveCard" />
          <span class="lbl"
            >Do you want to save your card information for your next
            purchase?</span
          >
        </label>
        <button class="button" type="submit">Pay</button>
        <div class="cards-logos">
          <img src="@/assets/visa.png" alt="visa" class="main-logo" />
          <img
            src="@/assets/mastercard.png"
            alt="mastercard"
            class="main-logo"
          />
        </div>
      </form>

      <form
        @submit.prevent="submit_reccuring"
        class="form"
        v-if="previous_customer"
      >
        <!-- Existing saved cards -->
        <label class="label" v-for="(card, index) in customerData" :key="index">
          <input
            type="radio"
            :value="card"
            v-model="selected_card"
            name="saved_card"
          />
          <span class="lbl">{{ card.card }}</span>
          <button
            class="delete-button"
            type="button"
            @click="deleteCard(card.id)"
          >
            <v-icon name="fa-trash" />
          </button>
        </label>

        <!-- Option to add a new card -->
        <label class="label">
          <input
            type="radio"
            value="new"
            v-model="selected_card"
            name="saved_card"
          />
          <span class="lbl">Add a new card</span>
        </label>

        <span class="error-message">{{ error_message }}</span>
        <button class="button" type="submit" :disabled="loading">
          <span v-if="loading" class="loader-inline"></span>
          <span v-else>Pay</span>
        </button>
        <div class="cards-logos">
          <img src="@/assets/visa.png" alt="visa" class="main-logo" />
          <img
            src="@/assets/mastercard.png"
            alt="mastercard"
            class="main-logo"
          />
        </div>
      </form>
    </div>
  </div>
  <!-- <div id="lll" v-if="loading === true">
    <div class="loader"></div>
  </div> -->
</template>

<script>
import axios from "axios";

export default {
  name: "TokenizationPage",
  // props: {
  //   msg: String,
  // },
  data() {
    return {
      shop: "",
      domain: "",
      config: {},
      session: {},
      save_card: false,
      paymentSession: {},
      customerData: [],
      previous_customer: false,
      payment_session_id: "",
      selected_card: null,
      error_message: "",
      loading: false,
    };
  },
  watch: {
    selected_card(newCard) {
      if (newCard === "new") {
        console.log("User wants to add a new card");
        // Optionally show a card input form here
      } else {
        console.log("Selected existing card:", newCard);
      }
    },
  },
  methods: {
    async getData(shop, domain, payment_session_id) {
      const paymentSession = await axios
        .get(`/paymentSession/get?paymentSession=${payment_session_id}`)
        .then((resp) => {
          // console.log("Payment Session:", resp.data);

          this.paymentSession = resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Payment Session:", err.response.data);
        });

      const config = await axios
        .get(`/configuration/get?shop=${shop || domain}`)
        .then((resp) => {
          this.config = resp.config;
          // return resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Config:", err.response.data);
        });

      const session = await axios
        .get(`/session/get?shop=${shop || domain}`)
        .then((resp) => {
          // console.log("Session:", resp.data);
          // return resp.data;
          this.session = resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Session:", err.response.data);
        });

      const customerData = await axios
        .get(
          `/customerData/get?shop=${shop}&email=${this.paymentSession.customer.email}`
        )
        .then((resp) => {
          // console.log("Customer Data:", resp.data);
          // return resp.data;
          this.customerData = resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Customer Data:", err.response.data);
        });

      // this.config = config;
      // this.session = session;
      // this.paymentSession = paymentSession;
      // this.customerData = customerData;
      return {
        config: config,
        session: session,
        paymentSession: paymentSession,
        customerData: customerData,
      };
    },
    async submit() {
      this.loading = true;
      await axios
        .post("/recurring-payment-init", {
          save_card: this.save_card,
          shop: this.shop,
          payment_session_id: this.payment_session_id,
        })
        .then((resp) => {
          console.log("Resp:", resp.data);
          window.location.href = resp.data.data.redirect_url;
          return resp.data;
        })
        .catch((err) => {
          console.error(err);
          alert("Submition failed");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async deleteCard(id) {
      await axios
        .delete(`/customerData/delete?id=${id}`)
        .then(async () => {
          await axios
            .get(
              `/customerData/get?shop=${this.shop}&email=${this.paymentSession.customer.email}`
            )
            .then((resp) => {
              // console.log("Customer Data:", resp.data);
              // return resp.data;
              this.customerData = resp.data;
            })
            .catch((err) => {
              console.log("Error in getting Customer Data:", err.response.data);
            });
        })
        .catch((err) => {
          console.log("Error in getting Customer Data:", err.response.data);
        });
    },
    async submit_reccuring() {
      this.loading = true;
      if (this.selected_card === "new") {
        console.log("Redirecting to new card input or payment page...");
        // Handle adding a new card flow here
        await axios
          .post("/recurring-payment-init", {
            save_card: true,
            shop: this.shop,
            payment_session_id: this.payment_session_id,
          })
          .then((resp) => {
            console.log("Resp:", resp.data);
            window.location.href = resp.data.data.redirect_url;
            return resp.data;
          })
          .catch((err) => {
            console.error(err);
            alert("Submition failed");
          });
      } else {
        await axios
          .post("/recurring-payment", {
            card: this.selected_card,
            payment_session_id: this.payment_session_id,
          })
          .then((resp) => {
            // console.log("Resp:", resp.data);
            window.location.href = resp.data.data.redirect_url;
          })
          .catch((err) => {
            this.error_message = err.response.data.message;
            // this.loading = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    toggleSaveCard() {
      this.save_card = !this.save_card;
    },
  },
  async mounted() {
    const shop = this.$route.query.shop;
    const domain = this.$route.query.domain;
    const payment_session_id = this.$route.query.payment_session_id;
    this.payment_session_id = payment_session_id;
    // console.log("Shop:", shop);
    // if (shop & payment_session_id) {
    this.shop = shop;
    this.domain = domain;
    await this.getData(shop, domain, payment_session_id);

    if (this.customerData.length > 0) {
      this.previous_customer = true;
    } else {
      this.previous_customer = false;
    }
    // }
  },
  beforeUnmount() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

#config_page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      max-height: 70px;
      aspect-ratio: auto;
    }
  }
}

#lll {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .loader {
    margin-top: 2rem;
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 8px solid #155eef;
    animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;
  }
}
@keyframes l20-1 {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
  }
  12.5% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
  }
  25% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
  }
  50% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  62.5% {
    clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  75% {
    clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  100% {
    clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
  }
}
@keyframes l20-2 {
  0% {
    transform: scaleY(1) rotate(0deg);
  }
  49.99% {
    transform: scaleY(1) rotate(135deg);
  }
  50% {
    transform: scaleY(-1) rotate(0deg);
  }
  100% {
    transform: scaleY(-1) rotate(-135deg);
  }
}

.index {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0f0c22;
  overflow: hidden;
}

.gradient {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at center,
    #6ed7ca,
    rgba(255, 255, 255, 0)
  );
  animation: moveBlob 20s infinite;
  border-radius: 50%;
  filter: blur(100px);
}

@keyframes moveBlob {
  0% {
    transform: translate(-70%, -70%) scale(1);
  }
  25% {
    transform: translate(70%, -70%) scale(2);
  }
  50% {
    transform: translate(-70%, 70%) scale(1);
  }
  75% {
    transform: translate(70%, 70%) scale(2);
  }
  100% {
    transform: translate(-70%, -70%) scale(1);
  }
}

/* This is just to transition when you change the viewport size. */
* {
  transition: all 0.5s ease-out;
  font-family: "Manrope", serif !important;
  font-optical-sizing: auto;
  font-style: normal;
}

.heading,
.text {
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: white;
  border: none;
}

.text {
  font-size: 1.2rem;
  padding-bottom: 2rem;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  z-index: 1;
  color: white;
  width: 100%;
  background-color: transparent;
}

.form {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  gap: 0.5rem;
  width: 50%;
  /* From https://css.glass */
  background: rgba(255, 255, 255, 0.22);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 2rem;
}

.images {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.images img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.images p {
  font-size: 30px;
}

.label {
  display: grid;
  gap: 0.5rem;
  width: calc(100% - 2rem - 2px);
  text-align: left;
  font-size: 1rem;
  background-color: transparent;
  background-color: #0f0c224f;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid white;
  border-radius: 10px;
  padding: 1rem;
}

.label:has(input[type="radio"]:checked) {
  border-color: #00dfdf; /* your highlight color */
  background-color: #198a8a;
}
/* .label:has(input[type="radio"]:checked) .lbl {
  color: #0f0c22;
} */

.lbl {
  font-size: 18px;
  width: 100%;
  background-color: transparent;
  color: white;
}

.input {
  padding: 1rem 1.5rem !important;
  border-radius: 8px;
  border: none;
  width: 100%;
}

.button {
  padding: 14px 24px;
  border-radius: 8px;
  background-color: #00dfdf;
  color: black;
  font-weight: 800;
  width: 100%;
  border: none;
  font-size: 1rem;
  margin: 0;
}

.button span {
  background-color: transparent;
}

.button:hover {
  background-color: white;
  cursor: pointer;
}

.list {
  list-style: none;
  padding: 0;
  padding-top: 3rem;
  margin: 0;
  display: flex;
  gap: 2rem;
}

.list > li {
  max-width: 20rem;
  text-align: left;
}

.sec {
  background-color: transparent;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
}
.dlabel {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  background-color: transparent;

  input {
    border-radius: 50%;
    overflow: hidden;
  }
}

.ov-icon {
  width: 24px;
  height: 24px;
  fill: white;
  background-color: transparent;
}
.label:has(input[type="radio"]:checked) .ov-icon {
  fill: #ffffff;
}
.label:has(input[type="radio"]:checked) .ov-icon:hover {
  fill: red;
}

.ov-icon:hover {
  fill: red;
}

.delete-button {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

.main-logo {
  background-color: transparent;
  width: 10%;
  height: auto;
}

.cards-logos {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  gap: 0.5rem;
}
.cards-logos img {
  border-radius: 5px;
  width: 45px;
  height: auto;
  margin: 0;
}

.error-message {
  background-color: transparent;
  color: red;
  text-align: center;
  font-weight: bold;
  width: 100%;
}

.button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loader-inline {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.4);
  border-top: 3px solid black;
  border-radius: 50%;
  display: inline-block;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 426px) {
  .form {
    width: 70%;
  }

  .main-logo {
    width: 50%;
  }
}
</style>
